import { Component, Input } from '@angular/core';

@Component({
    selector: '[titolo_esecutivo_entity_view]',
  templateUrl: 'titolo-esecutivo-entity-view.component.html',
})

export class TitoloEsecutivoEntityViewComponent {
  @Input()
  element;
}
